import type { ResizedWidth } from './types';

// A dragged tile width lives in a CSS variable on the surface. A drag rewrites only that variable,
// so the engine does not re-render and Main follows the tile in the same frame.
export const tileWidthVar = (resizeKey: string): `--${string}` => `--tile-width-${resizeKey.replace(/[^\w-]/g, '_')}`;

// 'max' asks for the whole surface; every resizable width clamps it down to its own maximum.
export const resizedWidthCssValue = (width: ResizedWidth): string => (width === 'max' ? '100%' : `${width}px`);

// Keeps a strip of the page visible next to a widened dock.
const RESIZED_DOCK_MAX_WIDTH = 'calc(100% - 25rem)';

// A dragged width only ever widens a dock: content that needs more room than the dragged width
// still gets `baseWidth`.
export const resizableDockWidth = (baseWidth: string, resizeKey: string): string =>
    `max(${baseWidth}, min(var(${tileWidthVar(resizeKey)}, 0px), ${RESIZED_DOCK_MAX_WIDTH}))`;
